import { gql } from '@apollo/client'
import PublicProfileFragment from './fragments/PublicProfile.fragment'
import PersonalProfileFragment from './fragments/PersonalProfile.fragment'
export const MY_PRIVATE_PROFILE = gql`
  query MyPrivateProfile($id: HashedId!) {
    personalProfile(id: $id) {
      ...PersonalProfile
    }
  }
  ${PersonalProfileFragment}
`

export const PUBLIC_PROFILE = gql`
  query publicProfile($id: HashedId!) {
    publicProfile(id: $id) {
      ...PublicProfile
    }
  }
  ${PublicProfileFragment}
`

export const RESIGNED_EMPLOYEE_PUBLIC_PROFILE = gql`
  query ResignedEmployeePublicProfile($id: HashedId!) {
    resignedEmployeePublicProfile(id: $id) {
      ...PublicProfile
    }
  }
  ${PublicProfileFragment}
`

export const LOCALES = gql`
  query Locales {
    locales {
      country
      locale
    }
  }
`
